import { Shark } from "shark-mvc";
import { NousCore } from "nouscore-js-api";

import ApplicatorTeam from "../../_shark_models/ApplicatorTeam";
import ManagerBase from "./ManagerBase";

class ApplicatorTeamManager extends ManagerBase {
	constructor () {
		super("applicatorTeamManager");

		this.remoteClassName = "applicator-team";
	}

	async getList () {
		const rd = NousCore.api.createRequest();
		const requestedAction = "get-list";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						const applicatorTeamList = Shark.getInstanceList(ApplicatorTeam, data.items);

						applicatorTeamList.sort((a, b) => {
							if (a.name > b.name) {
								return 1;
							}
							else if (a.name < b.name) {
								return -1;
							}
						});

						Shark.set({
							applicatorTeamList,
							__applicatorTeamListRetrieved: true
						});

						applicatorTeamManager.emit("listChanged");
						return {
							data: applicatorTeamList,
							requestedAction,
							status: "ok"
						};
					}
					case 404:
						applicatorTeamManager.emit("listGetError");
						return {
							data,
							requestedAction,
							status: "ko"
						};
				}
			}
		});
	}



	delete () {
		const rd = NousCore.api.createRequest({ item: { guid: Shark.get("currVisit").guid }});
	
		NousCore.api.send("applicator-team/delete", rd, function (data) {
			console.log(data);
	
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						applicatorTeamManager.emit("visitDeleted");
						break;
					case 404:
						applicatorTeamManager.emit("visitDeletionError");
						break;
				}
			}
		});
	}
}

const applicatorTeamManager = new ApplicatorTeamManager();



// applicatorTeamManager.addMethod("save", function (applicatorTeam) {
// 	const rd = NousCore.api.createRequest({ item: applicatorTeam.export() });
// 	const action = applicatorTeam.guid === "" ? "insert" : "update";

// 	NousCore.api.send(`applicator-team/${action}`, rd, function (data) {
// 		if (data.isSuccess) {
// 			switch (data.rc) {
// 				case 1:
					
// 					applicatorTeam.import(data.items[0]);
// 					applicatorTeam.clean();
					
// 					if (action === "insert") {
// 						const applicatorTeamList = Shark.get("applicatorTeamList");
// 						applicatorTeamList.push(applicatorTeam);
// 					}

// 					applicatorTeamManager.emit("saved");
// 					break;
// 				case 99:
// 					applicatorTeamManager.emit("saveError");
// 					break;
// 			}
// 		}
// 	});
// });

Shark.registerController(applicatorTeamManager);

export default applicatorTeamManager;
